import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { switchMap } from 'rxjs';

import type { UserIdMap } from '@core/account-data';
import { UserSelectors } from '@core/account-data';
import type { Requisition, RequisitionAssignedFlow } from '@core/requisitions-types';
import { AssignedFlowsSelectors } from '@recruitee/requisitions-data';
import { RequisitionsConfigSelectors } from '@recruitee/requisitions-settings-data';

import { RootPageDataService } from './root-page-data.service';

@Injectable()
export class DetailsPageDataService {
  private readonly rootData = inject(RootPageDataService);
  private readonly store = inject(Store);

  public requisition$: Observable<Requisition>;
  public approvalFlow$: Observable<RequisitionAssignedFlow | null>;
  public adminsMap$: Observable<UserIdMap>;
  public isDepartmentsMode$: Observable<boolean>;

  constructor() {
    const rootData = this.rootData;
    const store = this.store;

    this.requisition$ = rootData.requisition$;
    this.approvalFlow$ = this.requisition$.pipe(
      switchMap(requisition =>
        store.select(AssignedFlowsSelectors.byRequisitionId({ requisitionId: requisition.id })),
      ),
    );
    this.adminsMap$ = store.select(UserSelectors.idMap);
    this.isDepartmentsMode$ = this.store.select(RequisitionsConfigSelectors.isDepartmentsMode);
  }
}
